/**
 * Checks if a variant is a ghost variant (ghost, ghostInvert, or ghostSecondary).
 * This is used by Button and IconButton components to determine styling behavior.
 *
 * @param variant - The variant to check
 * @returns true if the variant is a ghost variant, false otherwise
 */
const isGhostVariant = (variant?: string | undefined): boolean => {
  return variant?.includes('ghost') ?? false;
};

export default isGhostVariant;
